'use client'

import {useEffect, useRef, useState} from 'react'

const useProjectCardAnimation = () => {
	const cardRef                   = useRef(null)
	const [isVisible, setIsVisible] = useState(false)

	useEffect(() => {
		if (!cardRef.current) return

		const card = cardRef.current
		let rafId  = null

		const reveal = () => {
			rafId = requestAnimationFrame(() => setIsVisible(true))
		}

		const observer = new IntersectionObserver((entries) => {
			if (entries[0]?.isIntersecting) {
				reveal()
				observer.disconnect()
			}
		}, {rootMargin: '0px 0px -18% 0px'})

		observer.observe(card)

		return () => {
			observer.disconnect()
			if (rafId) cancelAnimationFrame(rafId)
		}
	}, [])

	return {cardRef, isVisible}
}

export default useProjectCardAnimation
